<div class="op" #opRoot>

  <!-- ==================================================================== -->
  <!-- HERO — premium marketplace                                            -->
  <!-- ==================================================================== -->
  <section class="op-hero" aria-labelledby="op-hero-title">
    <div class="op-hero__deco" aria-hidden="true">
      <span class="op-blob op-blob--1 op-parallax"></span>
      <span class="op-blob op-blob--2 op-parallax"></span>
      <span class="op-blob op-blob--3 op-parallax"></span>
      <span class="op-dots op-dots--1"></span>
      <span class="op-dots op-dots--2"></span>
      <span class="op-ring op-ring--1"></span>
      <span class="op-ring op-ring--2"></span>
      <span class="op-particle" style="--x: 14%; --y: 22%; --d: 0s"></span>
      <span class="op-particle" style="--x: 32%; --y: 74%; --d: 1.4s"></span>
      <span class="op-particle" style="--x: 62%; --y: 16%; --d: 2.3s"></span>
      <span class="op-particle" style="--x: 88%; --y: 58%; --d: 3.1s"></span>
      <span class="op-particle" style="--x: 74%; --y: 86%; --d: 4.2s"></span>
    </div>

    <div class="container op-hero__inner">
      <!-- ------------------------------------------------ left: copy ----- -->
      <div class="op-hero__copy">
        <span class="op-hero__badge rs-badge rs-badge--spark">
          <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
            <path d="M12 2.5l1.9 5.6 5.6 1.9-5.6 1.9L12 17.5l-1.9-5.6L4.5 10l5.6-1.9L12 2.5z" />
          </svg>
          Digital Marketplace
        </span>

        <h1 class="op-hero__title" id="op-hero-title">
          Our <span class="op-grad">Digital Products</span>
        </h1>

        <span class="op-hero__rule" aria-hidden="true"></span>

        <p class="op-hero__lede">
          Helping businesses launch faster with ready-made software products,
          enterprise solutions and customizable digital platforms.
        </p>

        <div class="op-hero__ctas">
          <button type="button" class="rs-btn rs-btn--primary op-magnet" rsRipple
            (click)="scrollToCatalogue()">
            <span>Explore Products</span>
            <span class="rs-btn__icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none">
                <path d="M5 12h13M13 6l6 6-6 6" stroke="currentColor" stroke-width="2.2"
                  stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </span>
          </button>

          <a class="rs-btn rs-btn--ghost op-magnet" routerLink="/contact-us">
            <span>Request Custom Product</span>
            <span class="rs-btn__icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none">
                <path d="M4 7.5h16v11H4zM4 7.5l8 6 8-6" stroke="currentColor" stroke-width="2"
                  stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </span>
          </a>
        </div>

        <ul class="op-hero__trust" aria-label="Track record">
          <li>
            <span class="op-tick" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none">
                <path d="M4 12.5l5 5L20 6.5" stroke="currentColor" stroke-width="2.6"
                  stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </span>
            Trusted by 250+ Businesses
          </li>
          <li>
            <span class="op-tick" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none">
                <path d="M4 12.5l5 5L20 6.5" stroke="currentColor" stroke-width="2.6"
                  stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </span>
            20+ Countries
          </li>
          <li>
            <span class="op-tick" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none">
                <path d="M4 12.5l5 5L20 6.5" stroke="currentColor" stroke-width="2.6"
                  stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </span>
            500+ Deployments
          </li>
        </ul>
      </div>

      <!-- ------------------------------------- right: floating showcase -- -->
      <div class="op-hero__visual" aria-hidden="true">
        <div class="op-stage">
          <span class="op-stage__glow"></span>

          <!-- primary dashboard -->
          <div class="op-stage__layer op-stage__layer--desk" style="--d: 26">
            <div class="op-window">
              <span class="op-window__bar">
                <i></i><i></i><i></i>
                <em>Analytics overview</em>
              </span>
              <div class="op-window__body">
                <div class="op-kpis">
                  <span class="op-kpi"><b>₹4.2L</b><small>Revenue</small></span>
                  <span class="op-kpi"><b>1,284</b><small>Orders</small></span>
                  <span class="op-kpi"><b>98%</b><small>Uptime</small></span>
                </div>
                <div class="op-chart">
                  <span style="--h: 42%; --i: 0"></span>
                  <span style="--h: 66%; --i: 1"></span>
                  <span style="--h: 38%; --i: 2"></span>
                  <span style="--h: 82%; --i: 3"></span>
                  <span style="--h: 54%; --i: 4"></span>
                  <span style="--h: 94%; --i: 5"></span>
                  <span style="--h: 70%; --i: 6"></span>
                </div>
                <div class="op-rows">
                  <span class="op-row"></span>
                  <span class="op-row"></span>
                  <span class="op-row"></span>
                </div>
              </div>
            </div>
          </div>

          <!-- tablet -->
          <div class="op-stage__layer op-stage__layer--tab" style="--d: 40">
            <div class="op-window op-window--tab">
              <span class="op-window__bar"><i></i><i></i><i></i></span>
              <div class="op-window__body">
                <div class="op-donut"></div>
                <div class="op-rows">
                  <span class="op-row"></span>
                  <span class="op-row"></span>
                </div>
              </div>
            </div>
          </div>

          <!-- mobile -->
          <div class="op-stage__layer op-stage__layer--phone" style="--d: 54">
            <div class="op-phone">
              <span class="op-phone__notch"></span>
              <div class="op-phone__body">
                <span class="op-phone__hero"></span>
                <span class="op-row"></span>
                <span class="op-row"></span>
                <span class="op-phone__cta"></span>
              </div>
            </div>
          </div>

          <!-- floating micro cards -->
          <span class="op-chip op-chip--analytics" style="--d: 62">
            <svg viewBox="0 0 24 24" fill="none">
              <path d="M4 19V9m5 10V5m5 14v-7m5 7V8" stroke="currentColor" stroke-width="2.2"
                stroke-linecap="round" />
            </svg>
            Analytics
          </span>
          <span class="op-chip op-chip--orders" style="--d: 48">
            <svg viewBox="0 0 24 24" fill="none">
              <path d="M4 6h13l-1.4 8H6.2L4 6zM6 20a1.4 1.4 0 100-2.8A1.4 1.4 0 006 20zm9 0a1.4 1.4 0 100-2.8A1.4 1.4 0 0015 20z"
                stroke="currentColor" stroke-width="1.9" stroke-linejoin="round" />
            </svg>
            Orders
          </span>
          <span class="op-chip op-chip--revenue" style="--d: 70">
            <svg viewBox="0 0 24 24" fill="none">
              <path d="M4 17l5-5 4 3 7-8" stroke="currentColor" stroke-width="2.2"
                stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            Revenue
          </span>
          <span class="op-chip op-chip--ai" style="--d: 58">
            <svg viewBox="0 0 24 24" fill="none">
              <path d="M12 3l1.7 5L19 9.7l-5.3 1.6L12 16.5l-1.7-5.2L5 9.7l5.3-1.7L12 3z"
                stroke="currentColor" stroke-width="1.8" stroke-linejoin="round" />
            </svg>
            AI
          </span>
          <span class="op-chip op-chip--charts" style="--d: 44">
            <svg viewBox="0 0 24 24" fill="none">
              <circle cx="12" cy="12" r="8" stroke="currentColor" stroke-width="1.9" />
              <path d="M12 4v8h8" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" />
            </svg>
            Charts
          </span>
          <span class="op-chip op-chip--bell" style="--d: 66">
            <svg viewBox="0 0 24 24" fill="none">
              <path d="M7 10a5 5 0 0110 0v4l1.6 2.4H5.4L7 14v-4zM10 19.5h4" stroke="currentColor"
                stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            Notifications
          </span>
        </div>
      </div>
    </div>
  </section>

  <!-- ==================================================================== -->
  <!-- SOLUTION RAIL — the product families (bannercardDetails)              -->
  <!-- ==================================================================== -->
  <section class="op-cats" aria-labelledby="op-cats-title">
    <div class="container">
      <div class="op-cats__head">
        <h2 class="op-cats__title" id="op-cats-title">Browse by solution</h2>
        <p class="op-cats__hint">
          <span aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none">
              <path d="M5 12h13M13 6l6 6-6 6" stroke="currentColor" stroke-width="2.2"
                stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </span>
          Scroll for more
        </p>
      </div>

      <ul class="op-cats__rail" role="list">
        <li *ngFor="let detail of bannercardDetails">
          <button type="button" class="op-cat"
            [class.is-active]="detail.category && activeFilter === detail.category"
            (click)="selectSolution(detail)">
            <span class="op-cat__ico">
              <img loading="lazy" class="imgSize" src="{{detail.image}}" alt="" />
            </span>
            <span class="op-cat__name">{{detail.title}}</span>
            <span class="op-cat__count" *ngIf="solutionCount(detail) as n">
              {{ n }} {{ n === 1 ? 'product' : 'products' }}
            </span>
          </button>
        </li>
      </ul>
    </div>
  </section>

  <!-- ==================================================================== -->
  <!-- CATALOGUE                                                             -->
  <!-- ==================================================================== -->
  <section class="op-catalogue" id="op-catalogue" aria-labelledby="op-catalogue-title">
    <div class="op-catalogue__deco" aria-hidden="true">
      <span class="op-blob op-blob--4 op-parallax"></span>
      <span class="op-blob op-blob--5 op-parallax"></span>
      <span class="op-dots op-dots--3"></span>
    </div>

    <div class="container">
      <header class="op-cat-head">
        <span class="rs-eyebrow rs-eyebrow--barred rs-eyebrow--center">Featured Products</span>
        <h2 class="op-h2" id="op-catalogue-title">Our <span class="op-grad">Products</span></h2>
        <p class="op-sub">Built. Focused. Loved by thousands.</p>
      </header>

      <!-- ------------------------------------------------- filter pills -- -->
      <div class="op-filters" role="tablist" aria-label="Filter products by category">
        <button type="button" class="op-pill" *ngFor="let f of filters"
          [class.is-active]="activeFilter === f.id" role="tab"
          [attr.aria-selected]="activeFilter === f.id" (click)="setFilter(f.id)">
          <span class="op-pill__label">{{ f.label }}</span>
          <span class="op-pill__count">{{ f.count }}</span>
        </button>
      </div>

      <!-- ------------------------------------------------- product grid -- -->
      <div class="op-grid">
        <article class="op-card" *ngFor="let card of visibleProducts">
          <span class="op-card__glow" aria-hidden="true"></span>

          <!-- media -->
          <div class="op-card__media">
            <div class="product_card" [ngStyle]="getUrl(card)" role="img"
              [attr.aria-label]="card.tittle"></div>

            <!-- subtle live-dashboard polish, purely decorative -->
            <span class="op-card__shimmer" aria-hidden="true"></span>
            <span class="op-card__spark" aria-hidden="true">
              <span style="--h: 40%"></span>
              <span style="--h: 72%"></span>
              <span style="--h: 52%"></span>
              <span style="--h: 88%"></span>
              <span style="--h: 64%"></span>
            </span>
            <span class="op-card__toast" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none">
                <path d="M4 12.5l5 5L20 6.5" stroke="currentColor" stroke-width="2.6"
                  stroke-linecap="round" stroke-linejoin="round" />
              </svg>
              Deployed
            </span>

            <span class="op-card__badges">
              <span class="op-card__cat" *ngIf="card.category">{{ categoryLabel(card.category) }}</span>
              <span class="op-card__version" *ngIf="card.version">{{ card.version }}</span>
            </span>
          </div>

          <!-- body -->
          <div class="card-body op-card__body">
            <span class="op-card__logo" aria-hidden="true">
              <img loading="lazy" [src]="card.image" alt="" />
            </span>

            <h3 class="card-title op-card__title">
              {{
                card.tittle.length > 28
                  ? card.tittle.substring(0, 28) + "..."
                  : card.tittle
              }}
            </h3>

            <p class="card-text op-card__text">{{ card.details }}</p>

            <!-- tech stack chips — render only for products that declare them -->
            <ul class="op-card__tags" *ngIf="card.tags?.length" aria-label="Built with">
              <li *ngFor="let tag of card.tags">{{ tag }}</li>
            </ul>

            <div class="op-card__meta">
              <span class="start-rate op-card__stars"
                [attr.aria-label]="card.rating + ' out of 5'">
                <span *ngFor="let star of getstarList(card.rating)">
                  <i class="{{ star }}" aria-hidden="true"></i>
                </span>
                <em>{{ card.rating }}</em>
                <small *ngIf="card.reviews">({{ card.reviews }} reviews)</small>
              </span>

              <span class="op-card__installs" *ngIf="card.installs">
                <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
                  <path d="M12 4v11M7 11l5 5 5-5M5 20h14" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                {{ card.installs }}
              </span>
            </div>

            <p class="op-card__price" *ngIf="card.price">
              <small>Starting at</small> <b>{{ card.price }}</b>
            </p>

            <div class="op-card__actions">
              <a class="btn btn-primary buy_btn rs-btn rs-btn--primary rs-btn--sm" rsRipple
                (click)="gotoDetail(card)" tabindex="0" role="button">
                <span>View Details</span>
                <span class="rs-btn__icon" aria-hidden="true">
                  <svg viewBox="0 0 24 24" fill="none">
                    <path d="M5 12h13M13 6l6 6-6 6" stroke="currentColor" stroke-width="2.2"
                      stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </span>
              </a>

              <!-- a real demo link when the product has one, otherwise a route
                   that actually exists — never a dead "Live Demo" button -->
              <a class="op-card__demo" *ngIf="card.demoUrl; else requestDemo"
                [href]="card.demoUrl" target="_blank" rel="noopener">
                Live Demo
                <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
                  <path d="M14 5h5v5M19 5l-8 8M18 14v5H5V6h5" stroke="currentColor"
                    stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </a>
              <ng-template #requestDemo>
                <a class="op-card__demo" routerLink="/contact-us">
                  Request Demo
                  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
                    <path d="M5 12h13M13 6l6 6-6 6" stroke="currentColor" stroke-width="2.2"
                      stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </a>
              </ng-template>
            </div>
          </div>
        </article>
      </div>

      <!-- nothing matches the active pill -->
      <div class="rs-empty op-empty" *ngIf="!visibleProducts.length">
        <span class="rs-empty__ico" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none">
            <circle cx="11" cy="11" r="7" stroke="currentColor" stroke-width="1.9" />
            <path d="M16.5 16.5L21 21" stroke="currentColor" stroke-width="1.9"
              stroke-linecap="round" />
          </svg>
        </span>
        <p class="rs-empty__title">No products in this category yet</p>
        <p class="rs-empty__text">
          We build custom solutions for every sector — tell us what you need and we
          will scope it with you.
        </p>
        <a routerLink="/contact-us" class="rs-btn rs-btn--primary rs-btn--sm" rsRipple>
          <span>Request a product</span>
          <span class="rs-btn__icon" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none">
              <path d="M5 12h13M13 6l6 6-6 6" stroke="currentColor" stroke-width="2.2"
                stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </span>
        </a>
      </div>
    </div>
  </section>

  <!-- ==================================================================== -->
  <!-- STATISTICS                                                            -->
  <!-- ==================================================================== -->
  <section class="op-stats" aria-label="Company results">
    <div class="container">
      <ul class="op-stats__grid" role="list">
        <li class="op-stat" *ngFor="let stat of stats; let i = index" [style.--i]="i">
          <span class="op-stat__val">
            <span class="op-stat__num" [attr.data-to]="stat.to">{{ stat.to }}</span
            ><em>{{ stat.suffix }}</em>
          </span>
          <span class="op-stat__label">{{ stat.label }}</span>
          <span class="op-stat__rule" aria-hidden="true"></span>
        </li>
      </ul>
    </div>
  </section>

  <!-- ==================================================================== -->
  <!-- CTA                                                                   -->
  <!-- ==================================================================== -->
  <section class="op-cta" aria-labelledby="op-cta-title">
    <div class="container">
      <div class="op-cta__panel">
        <span class="op-cta__mesh" aria-hidden="true"></span>
        <span class="op-cta__blob op-cta__blob--1" aria-hidden="true"></span>
        <span class="op-cta__blob op-cta__blob--2" aria-hidden="true"></span>
        <span class="op-dots op-dots--4" aria-hidden="true"></span>
        <span class="op-ring op-ring--3" aria-hidden="true"></span>

        <div class="op-cta__inner">
        <span class="rs-badge rs-badge--spark op-cta__badge">
          <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
            <path d="M12 2.5l1.9 5.6 5.6 1.9-5.6 1.9L12 17.5l-1.9-5.6L4.5 10l5.6-1.9L12 2.5z" />
          </svg>
          Let's Build Something Great Together
        </span>

        <h2 class="op-cta__title" id="op-cta-title">
          Need Something <span class="op-grad">Custom?</span>
        </h2>

        <p class="op-cta__text">
          We build fully customized enterprise solutions tailored to your business.
        </p>

        <div class="op-cta__actions">
          <a routerLink="/call-back" class="rs-btn rs-btn--primary op-magnet" rsRipple>
            <span>Book Consultation</span>
            <span class="rs-btn__icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none">
                <path d="M5 12h13M13 6l6 6-6 6" stroke="currentColor" stroke-width="2.2"
                  stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </span>
          </a>
          <a routerLink="/contact-us" class="rs-btn rs-btn--ghost op-magnet">
            <span>Contact Sales</span>
            <span class="rs-btn__icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none">
                <path d="M4 7.5h16v11H4zM4 7.5l8 6 8-6" stroke="currentColor" stroke-width="2"
                  stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </span>
          </a>
        </div>
        </div>
      </div>
    </div>
  </section>
</div>
